import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Grid} from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';
import { CityUserDetail } from '../dataObjects/WebsiteRealTimeCountSummary';

interface CityChartProps {
    cities?: CityUserDetail[];
}

export default function WebsiteUserByCityChart(props: CityChartProps) {

    const filteredData = props.cities?.filter(entry => entry.city && entry.city !== "(not set)" && entry.city !== "");

    const cities = filteredData?.map(entry => entry.city);
    const activeUsers = filteredData?.map(entry => parseInt(entry.activeUsers, 10));

  return (
      <>
         <Typography variant="h6" component={"h6"}>
              TOP 10 CITIES WITH MOST USERS
          </Typography>
          {
              cities &&
              <Grid item xs={12} paddingLeft={1}>      
                <BarChart
                    margin={{left:90}}
                    height={420}
                    width={420}
                    sx={{
                        "& .MuiChartsAxis-directionX": {
                            display: "none",
                        },
                        '& .MuiBarLabel-root': {
                            fill: 'white',
                            fontSize: '12px',
                            fontStyle: 'italic',
                            fontWeight: 'bold'
                        },
                     }}
                    layout="horizontal"
                    yAxis={[
                          {
                            data: cities,
                            scaleType: 'band',
                            categoryGapRatio: 0.4,
                            disableLine: true,
                            disableTicks: true,   
                            tickLabelStyle: {
                                 fontSize: 13,
                            },
                          } as any
                      ]} 
                    series={[
                          {
                              data: activeUsers,
                              color: '#02B2AF',
                              label: 'Active Users',
                          }
                          ]}
                     // This enables the bar labels
                    barLabel="value"
                  />
              </Grid>
          }
          
      </>
  );
}
